import type React from 'react';
import { Box, Divider, Modal } from '@zillow/constellation-10';
import { drawerBodyStyles, drawerRecipe } from './styles';
import useModal from '../../hooks/useModal';

export type DrawerProps = {
  alignment?: 'left' | 'right';
  renderHeader?: React.ReactNode;
  renderBody?: React.ReactNode;
  renderFooter?: React.ReactNode;
  onClose?: () => void;
  shouldCloseOnOutsideClick?: boolean;
};

export default function Drawer({
  alignment = 'right',
  renderHeader,
  renderBody,
  renderFooter,
  onClose,
  shouldCloseOnOutsideClick = false,
}: DrawerProps) {
  const { clearModal } = useModal();

  const handleClose = () => {
    clearModal();
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal.Root
      open={true}
      onOpenChange={(open) => !open && handleClose()}
      useDismissProps={{
        outsidePress: shouldCloseOnOutsideClick,
        escapeKey: true,
      }}
    >
      <Modal.Portal>
        <Modal.Content css={drawerRecipe.raw({ alignment })}>
          {renderHeader && (
            <>
              <Modal.Header>{renderHeader}</Modal.Header>
              <Divider />
            </>
          )}
          {renderBody && <Box css={drawerBodyStyles}>{renderBody}</Box>}
          {renderFooter && (
            <>
              <Divider />
              <Modal.Footer>{renderFooter}</Modal.Footer>
            </>
          )}
          <Modal.CloseButton />
        </Modal.Content>
      </Modal.Portal>
    </Modal.Root>
  );
}
